// AUTO-GENERATED — do not edit manually, run npm run icons
import { SvgIcon, type SvgIconProps } from '@mui/material';
import Svg from '@assets/icons/filled-pay-by-check.svg?react';

export const FilledPayByCheckIcon = (props: SvgIconProps) => (
  <SvgIcon component={Svg} inheritViewBox {...props} />
);
